import React, { PropTypes } from 'react';
import { compose } from 'recompose';
import { getAppContext } from '../../util/decorators';
import { connect } from 'react-redux';
import fetch from 'node-fetch';
import loadModal from 'action/loadModal';
import Stars from './Stars';
import Textarea from 'component/Forms/Textarea';
import Input from 'component/Forms/Input';
import Checkbox from 'component/Forms/Checkbox';
import VButton from 'component/VButton';

const SWEDEN = 'se';

const mapStateToProps = state => ({
  userRating: state.userRating,
  country: state.country,
});

// Component to show user feedback form
export class FeedbackFormComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.t = props.app.t;
    this.state = {
      message: '',
      name: '',
      email: '',
      notify: props.country === SWEDEN && props.defaultNotify,
    };

    this.onChangeMessage = message => this.setState({ message });
    this.onChangeName = name => this.setState({ name });
    this.onChangeEmail = email => this.setState({ email });
    this.onChangeNotify = notify => this.setState({ notify });

    this.closeForm = this.closeForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  closeForm() {
    this.props.dispatch(loadModal(''));
  }

  submitForm() {
    // If nothing to submit - just close form
    if (!this.props.userRating && !this.state.message && !this.state.email) {
      this.closeForm();
      return;
    }

    const data = Object.assign(
      {
        userRating: this.props.userRating || 0,
        userAgent: '',
        country: this.props.country,
      },
      this.state,
    );

    data.notify = data.notify ? 'Yes' : 'No';

    if (typeof navigator !== 'undefined') {
      data.userAgent = navigator.userAgent || '';
    }

    const dataMap = {
      message: 'entry.993972173',
      name: 'entry.704776241',
      email: 'entry.233493345',
      notify: 'entry.1008593796',
      userRating: 'entry.887976182',
      userAgent: 'entry.304756641',
      country: 'entry.133647328',
    };

    const body = Object.keys(dataMap)
      .map(
        key => `${dataMap[key]}=${encodeURIComponent(String(data[key] || ''))}`,
      )
      .join('&');

    fetch(
      'https://docs.google.com/a/viaplay.com/forms/d/e/1FAIpQLSeHhJHeCw4VO4WYNF4P7PBmMe68tEKJxWo6OHs13-5tgp3xZg/formResponse',
      {
        method: 'POST',
        body,
        headers: {
          Accept: 'application/xml, text/xml, */*',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      },
    ).catch(() => {
      // will always fail because of cross origin constraints
      this.closeForm();
    });
  }

  render() {
    return (
      <div className="feedback__form">
        <div className="feedback__form__title">
          {this.t('Feedback.formTitle')}
        </div>
        <Stars />
        <fieldset>
          <legend>{this.t('Feedback.message')}</legend>
          <Textarea onChange={this.onChangeMessage} />
        </fieldset>
        <fieldset>
          <legend>{this.t('Feedback.name')}</legend>
          <Input onChange={this.onChangeName} />
        </fieldset>
        <fieldset>
          <legend>{this.t('Feedback.email')}</legend>
          <Input inputType="email" onChange={this.onChangeEmail} />
        </fieldset>

        {this.props.country === SWEDEN &&
          <Checkbox
            name="notify"
            label={this.t('Feedback.notify')}
            prefilled={this.props.defaultNotify}
            onChange={this.onChangeNotify}
            className="feedback__form__notify"
          />}
        <div className="feedback__form__buttons">
          <VButton
            elementType="div"
            type="whiteblue"
            onClick={this.closeForm}
            className="feedback__form__buttons__button close">
            {this.t('Feedback.close')}
          </VButton>
          <VButton
            elementType="div"
            type="primary"
            onClick={this.submitForm}
            className="feedback__form__buttons__button submit">
            {this.t('Feedback.send')}
          </VButton>
        </div>
        <div
          className="feedback__form__mobile__close"
          onClick={this.closeForm}
        />
      </div>
    );
  }
}

FeedbackFormComponent.propTypes = {
  userRating: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  defaultNotify: PropTypes.bool,
  app: PropTypes.object.isRequired,
  country: PropTypes.string,
};

FeedbackFormComponent.defaultProps = {
  defaultNotify: true,
};

export default compose(connect(mapStateToProps), getAppContext)(
  FeedbackFormComponent,
);



// WEBPACK FOOTER //
// ./src/component/Feedback/FeedbackForm.jsx